import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import IconBirdLogo from 'components/icons/iconBirdLogo';
import CloseIcon from 'assets/icons/ico-close.svg';
import notificationBannerHelper from './utils';
const NotificationBannerSkeleton = t0 => {
  const $ = _c(29);
  const {
    title,
    icon,
    body,
    onClose,
    modifier,
    keepOpenOnMouseEnter: t1
  } = t0;
  const keepOpenOnMouseEnter = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== icon) {
    t2 = icon || <IconBirdLogo color="#27919C" style={{
      transform: "scale3d(calc(26/16), calc(19/11), 1)",
      margin: 0
    }} />;
    $[0] = icon;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const iconHTML = t2;
  const t3 = modifier !== "second";
  const t4 = modifier === "second";
  let t5;
  if ($[2] !== t3 || $[3] !== t4) {
    t5 = classNames("w-full md:w-[457px] cursor-auto border border-solid [border-color:#dbf0f0] rounded bg-[#f4f9fa] fixed flex items-start z-[1009] px-5 py-[1.375rem]", "animate-fade-in", "top-auto left-0 right-0", "md:left-auto md:bottom-auto md:right-[4.25rem]", {
      "md:top-[7.125rem] bottom-[5px]": t3,
      "md:top-[16.125rem] bottom-40": t4
    });
    $[2] = t3;
    $[3] = t4;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  let t7;
  if ($[5] !== keepOpenOnMouseEnter) {
    t6 = () => {
      if (keepOpenOnMouseEnter) {
        notificationBannerHelper.removeTimeout();
      }
    };
    t7 = () => {
      if (keepOpenOnMouseEnter) {
        notificationBannerHelper.hideMsgWithTimeout();
      }
    };
    $[5] = keepOpenOnMouseEnter;
    $[6] = t6;
    $[7] = t7;
  } else {
    t6 = $[6];
    t7 = $[7];
  }
  let t8;
  if ($[8] !== iconHTML) {
    t8 = <div className="[&_span]:![border-bottom:none]">{iconHTML}</div>;
    $[8] = iconHTML;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== title) {
    t9 = title && <div className="font-bold text-base text-gray">{title}</div>;
    $[10] = title;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] !== body) {
    t10 = body && <div className="text-base text-gray items-center flex [&_a]:text-base [&_a]:text-brand [&_a]:no-underline">{body}</div>;
    $[12] = body;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] !== t10 || $[15] !== t9) {
    t11 = <div className="!text-gray ml-4">{t9}{t10}</div>;
    $[14] = t10;
    $[15] = t9;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  let t12;
  if ($[17] !== onClose) {
    t12 = (...t13) => {
      const args = t13;
      notificationBannerHelper.hideMsg();
      if (onClose) {
        onClose(...args);
      }
    };
    $[17] = onClose;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  let t13;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <CloseIcon width={18} aria-hidden="true" />;
    $[19] = t13;
  } else {
    t13 = $[19];
  }
  let t14;
  if ($[20] !== t12) {
    t14 = <button type="button" aria-label="Close notification" className="[background:none] border-0 absolute right-4 top-[1.125rem] w-[12.25px] cursor-pointer p-0 [&_img]:m-0 [&_img]:text-gray" onClick={t12}>{t13}</button>;
    $[20] = t12;
    $[21] = t14;
  } else {
    t14 = $[21];
  }
  let t15;
  if ($[22] !== t11 || $[23] !== t14 || $[24] !== t5 || $[25] !== t6 || $[26] !== t7 || $[27] !== t8) {
    t15 = <div className={t5} onMouseEnter={t6} onMouseLeave={t7}>{t8}{t11}{t14}</div>;
    $[22] = t11;
    $[23] = t14;
    $[24] = t5;
    $[25] = t6;
    $[26] = t7;
    $[27] = t8;
    $[28] = t15;
  } else {
    t15 = $[28];
  }
  return t15;
};
NotificationBannerSkeleton.propTypes = {
  title: PropTypes.string,
  icon: PropTypes.string,
  body: PropTypes.node,
  onClose: PropTypes.func,
  modifier: PropTypes.oneOf(['second', 'top']),
  keepOpenOnMouseEnter: PropTypes.bool
};
export default NotificationBannerSkeleton;